import Nicknames from '../pages/Nicknames';
import MyNicknames from '../pages/MyNicknames';
import SingleNickname from '../pages/SingleNickname';
import Usernames from '../pages/Usernames';
import UsernamesSingle from '../pages/UsernamesSingle';
import Numbers from '../pages/Numbers';
import NumbersSingle from '../pages/NumbersSingle';
import Payment from '../pages/Payment';
import ActivateWallet from '../pages/ActivateWallet';
import ActivateUsername from '../pages/ActivateUsername';
import Tutorials from '../pages/Tutorials';
import About from '../pages/About';
import Terms from '../pages/Terms';
import Pricacy from '../pages/Pricacy';

export const SidebarData = {
  main: {
    path: '/',
    component: <Usernames />,
  },
  numbers: {
    path: '/numbers',
    component: <Numbers />,
  },
  tutorials: {
    path: '/tutorials',
    component: <Tutorials />,
  },
  singleUsername: {
    path: '/usernames/single',
    component: <UsernamesSingle />,
  },
  singleNumber: {
    path: '/numbers/single',
    component: <NumbersSingle />,
  },
  payment: {
    path: '/transaction/pay.cryptomus.com/:hash',
    component: <Payment />,
  },
  activateWallet: {
    path: '/wallet-activate',
    component: <ActivateWallet />,
  },
  activateUsername: {
    path: '/username-activate',
    component: <ActivateUsername />,
  },
  about: {
    path: '/about',
    component: <About />,
  },
  terms: {
    path: '/terms',
    component: <Terms />,
  },
  privacy: {
    path: '/privacy',
    component: <Pricacy />,
  },
};
